/**
 * @mixin TToggle/mixins/child
 * @desc TToggle 자식 컴포넌트에 사용하는 mixin 객체
 * @vue-data {Number|null} index - 고유 index
 * @vue-prop {Number} idx - 컴포넌트 root tag
 * @vue-computed {String} core - core class
 * @vue-computed {String} attrs - 속성
 * @vue-computed {String} listeners - 리스너
 * @vue-computed {String} selectedIndex - 선택된 index
 * @vue-computed {String} calcOnClass - 활성화 css 클래스
 */
export default {
  data() {
    return {
      index: null
    };
  },
  props: {
    idx: {
      type: Number
    }
  },
  computed: {
    core() {
      return this.$parent.core;
    },
    attrs() {
      return this.$attrs;
    },
    listeners() {
      return this.$listeners;
    },
    selectedIndex() {
      return this.$parent.selectedIndex;
    },
    calcOnClass() {
      return this.$parent.onClass ? this.$parent.onClass : this.onClass;
    }
  },
  mounted() {
    this.save();
  },
  methods: {
    save() {
      if (this.core.register) {
        let { index } = this.core.register(this);
        this.index = index;
      }
    }
  }
};
